// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d5ce57f1","498":"c5abbf02","513":"2480e104"}[chunkId] + ".chunk.js";
};